import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';

import App from './App';
import { ThemeProvider } from './context/theme-context';
import store from './store/configureStore';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
	<Provider store={store()}>
		<HelmetProvider>
			<ThemeProvider>
				<App />
			</ThemeProvider>
		</HelmetProvider>
	</Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
